import { useCallback } from "react";
import { deleteAdvisor, saveAdvisor, type SaveAdvisorInput } from "@/lib/api/advisors";
import { useDialog } from "@/lib/dialogs/DialogProvider";
import { useSession } from "@/lib/session/SessionContext";

/** Port der Berater-Aktionen aus src/components/admin/handlers.js. */
export function useAdvisorActions() {
  const { advisors, setAdvisors } = useSession();
  const { confirm, alert } = useDialog();

  const submitAdvisor = useCallback(
    async (input: SaveAdvisorInput) => {
      try {
        const result = await saveAdvisor(input);
        setAdvisors((list) => {
          const index = list.findIndex((advisor) => advisor.id === result.advisor.id);
          if (index >= 0) {
            const next = [...list];
            next[index] = { ...next[index], ...result.advisor };
            return next;
          }
          return [...list, { mustChangePassword: true, ...result.advisor }];
        });

        if ("delivery" in result) {
          if (result.delivery.delivered) {
            await alert(`Der Berater wurde angelegt. Die Zugangsdaten wurden per E-Mail an ${result.advisor.email} versendet.`, {
              title: "Zugangsdaten versendet"
            });
          } else {
            const reason = "reason" in result.delivery ? result.delivery.reason : "Mailversand nicht konfiguriert.";
            await alert(
              `Der Berater wurde angelegt, aber die Zugangsmail konnte nicht versendet werden: ${reason}\n\nEinmaliges Startpasswort:\n\n${result.initialPassword}\n\nBitte übermittle es sicher an den Berater.`,
              { title: "E-Mail nicht versendet" }
            );
          }
        }
        return result.advisor;
      } catch (error) {
        await alert(error instanceof Error ? error.message : "Die Anfrage ist fehlgeschlagen.");
        return null;
      }
    },
    [setAdvisors, alert]
  );

  const deleteAdvisorAction = useCallback(
    async (advisorId: string) => {
      const advisor = advisors.find((entry) => entry.id === advisorId);
      if (!advisor) return;
      const ok = await confirm(`Möchtest du den Berater "${advisor.name}" wirklich löschen?`, {
        title: "Berater löschen",
        confirmLabel: "Löschen",
        danger: true
      });
      if (!ok) return;
      await deleteAdvisor(advisorId);
      setAdvisors((list) => list.filter((entry) => entry.id !== advisorId));
    },
    [advisors, confirm, setAdvisors]
  );

  return { submitAdvisor, deleteAdvisorAction };
}
